import { render, staticRenderFns } from "./AccountCogOutline.vue?vue&type=template&id=2c51fa5a"
import script from "./AccountCogOutline.vue?vue&type=script&lang=js"
export * from "./AccountCogOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports